import { BaseService } from "services/_baseService";

class CounterpartiesAdminService extends BaseService<any> {
  constructor() {
    super(`baggage-counterparties`);
  }
}

export default new CounterpartiesAdminService();
